<app-navbar></app-navbar>
<div
  class="card"
  style="
    padding: 20px; //background-image: url('assets/img/school/bg.png');
    background-color: #005a63;
    background-size: 100px;
    background-attachment: fixed;
  "
>
  <h2 style=" color: white;  text-align: center; margin-bottom: 10px">
    Speech and Language Therapy (SLT)
  </h2>
  <div>
    <img
      class="img-fluid"
      style="height: 500px; width: 100%; object-fit: cover; border-radius: 10px"
      src="assets/img/school/news/9.jpeg"
    />
  </div>
  <br />
  <br />
  <div class="container" style="text-align: justify !important">
    <div class="row">
      <div class="col-md-12">
        <p style="color: white;">
          Speech and Language Therapy is a scientific medical procedure through
          which all individuals from children to the elderly are able to
          understand speech/language, to be able to speak, to assist in chewing
          or swallowing. Speech & Language Therapy department of
          Proyash-Chattogram uses international standard assessment tools for
          treatment plan for improvement of communication. <br />
          At Proyash-Chattogram, Speech & Language therapist team provides
          proper treatment of these area of communication problems: <br />
          • Stuttering. <br />
          • Language delay and disorder. <br />
          • Speech delay and disorder. <br />
          • Articulation and phonological disorders. <br />
          • Difficulty in eating (chewing and swallowing) etc. <br />
          Speech & Language therapy provides 1:1 session and train the parents &
          teachers to help a child how to communicate in all environment. Speech
          & Language therapist uses international therapy tools for a child to
          ensure better communication in regular life.
        </p>
      </div>
    </div>
  </div>
</div>
